export interface HttpTelemetryEvent {
  method: string;
  url: string;
  status: number;
  durationMs: number;
  succeeded: boolean;
  errorKind?: string;
}

export abstract class TelemetryService {
  abstract trackHttpRequest(event: HttpTelemetryEvent): void;
}
